import { Component, Input } from '@angular/core';
import { CalendarDateRange } from '@app/shared/models/volume-dashboard.model';
import { comparisonRangeLabel } from '@app/shared/utilities/volume-comparison';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-comparison-period-label',
  templateUrl: './comparison-period-label.component.html',
  standalone: false,
})
export class ComparisonPeriodLabelComponent {
  @Input() comparisonPeriod: CalendarDateRange | null = null;
  @Input() isLoading = false;

  constructor(private translate: TranslateService) {}

  get comparisonLabel(): string {
    return comparisonRangeLabel(this.comparisonPeriod, this.translate.currentLang);
  }
}
